import { useEffect, useState } from "react";

export default function WallClock() {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const bkk = new Date(now).toLocaleTimeString("en-GB", {
    hour12: false,
    timeZone: "Asia/Bangkok",
  });
  const utc = new Date(now).toLocaleTimeString("en-GB", {
    hour12: false,
    timeZone: "UTC",
  });
  return (
    <div className="wallclock">
      <span className="wc-pair">
        <span className="wc-k">BKK</span>
        <span className="wc-v">{bkk}</span>
      </span>
      <span className="wc-sep">·</span>
      <span className="wc-pair">
        <span className="wc-k">UTC</span>
        <span className="wc-v">{utc}</span>
      </span>
    </div>
  );
}
